import { EchartsWithTheme, Empty, useTheme } from '@maxtropy/components';
import { Skeleton } from 'antd';
import React, { FC } from 'react';
import ReactEcharts from 'echarts-for-react';
import useEchartsTheme from '@/shared/hooks/useEchartsTheme';

export interface ChartProps {
  loading?: boolean;
  chartData?: any;
  option?: any;
  height?: number;
}

const Chart: FC<ChartProps> = props => {
  const { option, chartData, height } = props;
  const theme = useTheme();

  return (
    <>
      <Skeleton style={{ padding: '120px 80px' }} loading={props.loading} paragraph={{ rows: 6 }}>
        <EchartsWithTheme
          empty={{
            isShowEmpty: !(chartData && chartData.length > 0),
            emptyNode: <Empty style={{ height: 450, padding: '120px 80px' }} />,
          }}
          option={option}
          style={{ height: height ?? 'calc(100% - 16px)' }}
          theme={theme}
        />
      </Skeleton>
    </>
  );
};

export default Chart;
